export function getMenu(i18n) {
  const t = i18n ? i18n.t.bind(i18n) : key => key;

  return [
    {
      displayText: t("message.menu.home"),
      icon: "api/menu-icons/home.svg",
      iconClass: "mdi mdi-home",
      pageName: "DashboardPage",
      role: []
    },
    {
      displayText: t("message.menu.orders"),
      icon: "api/menu-icons/ecommerce.svg",
      iconClass: "mdi mdi-cart",
      pageName: "OrdersPage",
      role: ["superadmin"],
      specialPermission: "can_view_orders"
    },
    {
      displayText: t("message.menu.customers"),
      icon: "api/menu-icons/users.svg",
      iconClass: "mdi mdi-account-group",
      pageName: "InfoautoCustomersPage",
      role: ["superadmin"],
      specialPermission: "can_view_customers"
    },
    {
      displayText: t("message.menu.infoauto"),
      icon: "api/menu-icons/infoauto.jpg",
      iconClass: "mdi mdi-car-info",
      pageName: "InfoautoOrdersPage",
      role: ["superadmin"],
      settings: ["infoauto_orders_sync_enabled"],
      specialPermission: "can_sync_infoauto_orders"
    },
    {
      displayText: t("message.menu.products"),
      icon: "api/menu-icons/product.svg",
      iconClass: "mdi mdi-magnify",
      pageName: "ProductsSearchPage",
      role: []
    },
    {
      displayText: t("message.menu.returns"),
      icon: "api/menu-icons/ecommerce.svg",
      iconClass: "mdi mdi-keyboard-return",
      pageName: "ReturnsPage",
      role: ["superadmin"],
      specialPermission: "can_view_returns"
    },
    {
      displayText: t("message.menu.upload_files"),
      icon: "api/menu-icons/upload-clear.svg",
      iconClass: "mdi mdi-cloud-upload",
      pageName: "uploadsPage",
      role: ["superadmin"],
      specialPermission: "can_upload_files"
    },
    {
      displayText: t("message.menu.report_generator"),
      icon: "api/menu-icons/report.svg",
      iconClass: "mdi mdi-chart-line",
      pageName: "reportGenerator",
      role: ["superadmin"],
      specialPermission: "can_request_report"
    },
    {
      displayText: t("message.menu.lost_sales"),
      icon: "api/menu-icons/pending.svg",
      iconClass: "mdi mdi-clock",
      pageName: "PendingProducts",
      role: ["superadmin"],
      specialPermission: "can_edit_pending_products"
    },
    {
      displayText: t("message.menu.store_settings"),
      icon: "api/menu-icons/stores.svg",
      iconClass: "mdi mdi-store",
      pageName: "StoreSettingsPage",
      role: ["superadmin"],
      specialPermission: "can_edit_store_settings"
    },
    {
      // Camiones del sitio de NKR Motors Group: sólo existen en Costa Rica.
      displayText: t("message.menu.trucks"),
      icon: "api/menu-icons/stores.svg",
      iconClass: "mdi mdi-truck",
      pageName: "TrucksPage",
      role: ["superadmin"],
      stores: ["nkr_costa_rica"],
      specialPermission: "can_edit_store_settings"
    },
    {
      displayText: t("message.menu.resale_tax"),
      icon: "api/menu-icons/stores.svg",
      iconClass: "mdi mdi-file-certificate",
      pageName: "ResaleTax",
      role: ["superadmin"],
      specialPermission: "resale_tax_management"
    },
    {
      displayText: t("message.menu.marketplaces"),
      icon: "api/menu-icons/market.svg",
      iconClass: "mdi mdi-shopping",
      pageName: "Marketplaces",
      role: ["superadmin"],
      specialPermission: "can_edit_marketplaces_items"
    },
    {
      displayText: t("message.menu.supersession"),
      icon: "api/menu-icons/number.svg",
      iconClass: "mdi mdi-swap-horizontal",
      pageName: "SupersessionManagerPage",
      role: ["superadmin"],
      specialPermission: "can_edit_supersession"
    },
    {
      displayText: t("message.menu.statistics"),
      icon: "api/menu-icons/chart.svg",
      iconClass: "mdi mdi-chart-bar",
      pageName: "StatisticsPage",
      role: ["superadmin"],
      specialPermission: "can_view_statistics"
    },
    {
      displayText: t("message.menu.wholesale_statistics"),
      icon: "api/menu-icons/chart.svg",
      iconClass: "mdi mdi-chart-line-variant",
      pageName: "WholesaleStatisticsPage",
      role: ["superadmin"],
      specialPermission: "can_view_wholesale_statistics"
    },
    {
      displayText: t("message.menu.pos_payments"),
      icon: "api/menu-icons/payments.svg",
      iconClass: "mdi mdi-point-of-sale",
      pageName: "PosPaymentsPage",
      role: ["superadmin"],
      specialPermission: "can_view_pos_payments"
    },
    {
      displayText: t("message.menu.payments"),
      icon: "api/menu-icons/payments.svg",
      iconClass: "mdi mdi-credit-card",
      pageName: "PaymentsPage",
      role: ["superadmin"],
      specialPermission: "can_view_web_payments"
    },
    {
      displayText: t("message.menu.alerts"),
      icon: "api/menu-icons/alert.svg",
      iconClass: "mdi mdi-alert-circle",
      pageName: "AlertsPage",
      role: ["superadmin"]
    },
    {
      displayText: t("message.menu.manage_users"),
      icon: "api/menu-icons/users.svg",
      iconClass: "mdi mdi-account-cog",
      pageName: "UsersPage",
      role: ["superadmin"],
      specialPermission: "manage_users"
    },
    {
      displayText: t("message.menu.map"),
      icon: "api/menu-icons/map.svg",
      iconClass: "mdi mdi-map",
      pageName: "MapPage",
      role: ["superadmin"]
    },
    {
      displayText: t("message.menu.chat"),
      iconClass: "mdi mdi-chat",
      pageName: "ChatPage",
      role: ["superadmin"],
      specialPermission: "can_view_chat"
    },
    {
      displayText: t("message.menu.form_seller_customer"),
      iconClass: "mdi mdi-file-document-outline",
      pageName: "FormSellerCustomerPage",
      role: ["superadmin"],
      specialPermission: "can_view_forms"
    },
    {
      displayText: t("message.menu.image_generator"),
      iconClass: "mdi mdi-image-plus",
      pageName: "ImageGeneratorPage",
      role: ["superadmin"],
      specialPermission: "can_use_ia_features"
    }
    // Add more menu items here as needed
    // Each menu item should have both 'icon' (for legacy support) and 'iconClass' (for MDI icons)
  ];
}
